import { NextQuery } from '@empathy/search-types';
import { EmpathyXConfig, QuerySignalsState } from '../../../models';
import { normalizeString } from '../../../utils';
import { GETTERS_KEYS } from '../../store.const';
import { RootStoreState } from '../../store.interfaces';
import { QUERY_SIGNALS_GETTERS_KEYS } from '../query-signals.const';
import { QuerySignalsGetter } from '../query-signals.interfaces';

export class NextQueriesGetter implements QuerySignalsGetter {
  getters = {
    [QUERY_SIGNALS_GETTERS_KEYS.nextQueries]:
      (querySignalsState: QuerySignalsState, getters: any, rootState: RootStoreState, rootGetters: any): NextQuery[] => {
        const { nextQueries: config }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
        const sessionQueryHistory = rootState.history.sessionQueryHistory;
        return config.filterBySessionQueryHistory
          ? querySignalsState.nextQueries.filter(nextQuery => !sessionQueryHistory.includes(normalizeString(nextQuery.query)))
          : querySignalsState.nextQueries;
      }
  };
}
